import { useEffect } from "react";
import Hero from "@/sections/Hero";
import Problem from "@/sections/Problem";
import Solution from "@/sections/Solution";
import HowItWorks from "@/sections/HowItWorks";
import SmartFeatures from "@/sections/SmartFeatures";
import DesignedForUAE from "@/sections/DesignedForUAE";
import Comparison from "@/sections/Comparison";
import BusinessSolutions from "@/sections/BusinessSolutions";
import Pricing from "@/sections/Pricing";
import Investors from "@/sections/Investors";
import EarlyAccess from "@/sections/EarlyAccess";
import FAQ from "@/sections/FAQ";
import Contact from "@/sections/Contact";
import { useI18n } from "@/lib/i18n";

export default function Home() {
  const { lang } = useI18n();

  useEffect(() => {
    document.title =
      lang === "ar"
        ? "ركنتي الإمارات | مساعد الركن الذكي بالذكاء الاصطناعي"
        : "Raknati UAE | AI-Powered Smart Parking Assistant";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        lang === "ar"
          ? "ركنتي يساعد سائقي الإمارات على حفظ موقع الركن والطابق والمنطقة والموقف والمعالم، ثم يرشدهم للعودة عبر ذاكرة ركن ذكية وتنبيهات وخرائط وملاحة."
          : "Raknati helps UAE drivers save their parking location, floor, zone, bay and visual landmarks, then guides them back using AI-powered parking memory, reminders, maps and smart navigation."
      );
    }
  }, [lang]);

  return (
    <main data-testid="home-main">
      <Hero />
      <Problem />
      <Solution />
      <HowItWorks />
      <SmartFeatures />
      <DesignedForUAE />
      <Comparison />
      <BusinessSolutions />
      <Pricing />
      <Investors />
      <EarlyAccess />
      <FAQ />
      <Contact />
    </main>
  );
}
